// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"ContactsGrid_gridContainer__2hDC_","gridOverlay":"ContactsGrid_gridOverlay__3XXPy"};